import React from 'react'

const SvgMicrophoneOffFilled = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path d='M19.026 14.819l-1.494-1.495c.301-.715.468-1.5.468-2.324a1 1 0 012 0 7.935 7.935 0 01-.974 3.819zM8.42 4.213l1.59 1.59L14 9.793l1.934 1.934c.043-.236.066-.479.066-.727V6a4 4 0 00-7.58-1.787zM3.707 2.293a1 1 0 00-1.414 1.414L8 9.414V11a4 4 0 005.352 3.766l1.508 1.508A5.964 5.964 0 0112 17c-3.309 0-6-2.692-6-6a1 1 0 10-2 0c0 4.071 3.061 7.435 7 7.93V20H9a1 1 0 000 2h6a1 1 0 000-2h-2v-1.07a7.964 7.964 0 003.313-1.203l3.98 3.98a1 1 0 001.414-1.414l-18-18z' />
  </svg>
)

export default SvgMicrophoneOffFilled
